import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbAccordionModule, NgbCarouselModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { LoginService } from "../../authentication/services/login.service";
import { RouterLink } from "@angular/router";
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';

@Component({
  selector: 'app-vertical-navigation',
  standalone: true,
  templateUrl: './vertical-navigation.component.html',
  imports: [NgbDropdownModule, FeatherModule, NgScrollbarModule, CommonModule,
    NgbAccordionModule, NgbCarouselModule, RouterLink],
  providers: [LoginService],
})
export class VerticalNavigationComponent implements OnInit {

  @Output() toggleSidebar = new EventEmitter<unknown>();

  menuAdmin = [];
  isSuperAdmin = false;
  user: any;

  constructor(private login: LoginService, private modalService: NgbModal) {
    this.userCredentials();
    this.isSuperAdmin = this.login.getIsSuperAdmin();

  }


  async ngOnInit() {
    this.initializeMenu();
  }

  async initializeMenu() {
    try {

      // Obtener y parsear el menú desde localStorage
      const storedMenuAdmin: any = this.login.getMenuAdmin() || [];
      ////console.log('storedMenuAdmin', storedMenuAdmin);
      const menuAdminArray = storedMenuAdmin.map(item => ({
        ...item,
        btn: 'btn-info',
        permission: true,
        path: `/administration/${item.path}`
      }));
      // if (!menuAdminArray.some(item => item.path === '/administration/causals')) {
      //   menuAdminArray.push({
      //     name: 'Crear Causales',
      //     icon: 'fas fa-list-check',
      //     btn: 'btn-warning',
      //     permission: true,
      //     path: '/administration/causals'
      //   });
      // }
      ////console.log('menuAdminArray procesado:', menuAdminArray);
      this.menuAdmin = menuAdminArray;
    } catch (error) {
      console.error('Error al inicializar el menú:', error);
    }
  }

  async userCredentials() {
    this.user = this.login.getUserInfo();
  }

  logout() {
    this.login.logout();
  }

  resetPassword(size: string) {
    const modalRef = this.modalService.open(ChangePasswordModalComponent, {
      scrollable: true,
      centered: false,
      backdrop: 'static',
      size,
    });
    modalRef.componentInstance.user = this.user;
  }

}
